import { useCallback, useEffect, useState } from "react";

interface Device {
    isMobile: boolean;
    isTablet: boolean;
}

export function useDeviceSelector() {
    const [device, setDevice] = useState(() => {
        const { isMobile, isTablet } = getDevice();
        return { isMobile, isTablet };
    });

    function getDevice() {
        const width = window.innerWidth;
        const isMobile = width <= 768;
        const isTablet = width > 768 && width <= 1024;

        return {
            isMobile,
            isTablet,
        };
    }

    const handleWindowSizeChange = useCallback(() => {
        const { isMobile, isTablet } = getDevice();
        setDevice({ isMobile, isTablet });
    }, []);

    useEffect(() => {
        handleWindowSizeChange();
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, [handleWindowSizeChange]);

    const isMobile = device.isMobile;
    const isTablet = device.isTablet;

    return {
        isMobile,
        isTablet,
        isDesktop: !isMobile && !isTablet,
    };
}
